import type { ReactNode } from 'react'
import { Icon, type IconName } from '@speaking-coach/ui'

export function DetailFact({label, children, icon, className, preserveWhitespace = false}: {
  label: string; children: ReactNode; icon?: IconName; className?: string; preserveWhitespace?: boolean
}): JSX.Element {
  return <div className={className}>
    <dt className="flex items-center gap-2 text-caption text-text-secondary">{icon && <Icon name={icon} size={16} aria-hidden="true" />}{label}</dt>
    <dd className={`mt-1 break-words text-body text-text-primary [&_a]:inline-block ${preserveWhitespace ? 'whitespace-pre-wrap' : ''}`}>{children == null || children === 'Not recorded' ? <span className="text-text-secondary italic">Not recorded</span> : children}</dd>
  </div>
}
